import { api } from './api';

const getMaximumLoadedAmount = async ({ customerId, vouId = 1 }) => {
  const response = await api({
    url: `OrderLimits/getMaximumLoadedAmount`,
    method: 'GET',
    params: {
      customerId,
      vouId,
    },
  });
  return response.data;
};

const getOrderLimitDate = (data) => {
  return api({
    url: `OrderLimits/GetOrderLimitDate`,
    method: 'GET',
    params: {
      customerId: data.customerId,
      vouId: data.vouId,
      tempOrderNo: data.tempOrderNo,
      orderTypeId: data.orderTypeId,
    },
  });
};

const orderLimitsServices = {
  getMaximumLoadedAmount,
  getOrderLimitDate,
};

export default orderLimitsServices;
